/**
 * AT1 Feedback Banner
 *
 * Bannière de feedback simple affichée sous les messages AT1.
 * Permet à l'agent de voter 👍 ou 👎 sur le message automatisé.
 */

/**
 * ============================================================================
 * AB TEST: Maturity AT1 Feedback Experiment (ab_at1_feedback)
 * PR: #2501
 *
 * This file is part of an A/B test experiment for collecting user feedback
 * on automatically generated AT1 messages. When the experiment concludes,
 * this entire file should be either:
 * - Removed if the experiment is unsuccessful
 * - Renamed (remove AB_ prefix) and integrated permanently if successful
 *
 * To find all AB test code: grep -r "ab_at1_feedback" src/
 * ============================================================================
 */

import { Box, IconButton, Typography } from '@evaneos/b2b-ui';
import ThumbUpIcon from '@evaneos/b2b-ui/icons/ThumbUp';
import ThumbDownIcon from '@evaneos/b2b-ui/icons/ThumbDown';
import { useIntl } from 'react-intl';

interface Props {
    onVote: (value: 1 | 0) => void;
}

export const AT1FeedbackBanner = ({ onVote }: Props) => {
    const { formatMessage } = useIntl();

    return (
        <Box
            sx={{
                mt: 1,
                paddingX: 2.5,
                paddingY: 1.5,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                backgroundColor: '#e3f2fd',
                gap: 2,
            }}
        >
            <Typography variant="body2">
                {formatMessage({ id: 'discussion.at1_feedback.banner.question' })}
            </Typography>
            <Box display="flex" gap={1}>
                <IconButton
                    size="small"
                    onClick={() => onVote(1)}
                    aria-label={formatMessage({
                        id: 'discussion.at1_feedback.banner.positive_aria',
                    })}
                >
                    <ThumbUpIcon />
                </IconButton>
                <IconButton
                    size="small"
                    onClick={() => onVote(0)}
                    aria-label={formatMessage({
                        id: 'discussion.at1_feedback.banner.negative_aria',
                    })}
                >
                    <ThumbDownIcon />
                </IconButton>
            </Box>
        </Box>
    );
};
